<template>

    <div id="sidebarNavigation" class="noPrint">
        <div class="list-group" v-if="!compact">
            <router-link to="/" active-class="active" exact class="list-group-item list-group-item-action">Domov</router-link>
            <router-link to="/classificationPlan" active-class="active" exact class="list-group-item list-group-item-action">Klasifikacijski načrt</router-link>
            <router-link to="/iskanjeDokumentov" active-class="active" class="list-group-item list-group-item-action">Iskanje dokumentov</router-link>
            <router-link to="/apm" active-class="active" exact class="list-group-item list-group-item-action">APM</router-link>
            <router-link to="/admin-tools" active-class="active" exact class="list-group-item list-group-item-action">Admin orodja</router-link>
            <router-link to="/status" active-class="active" exact class="list-group-item list-group-item-action">Predpomnilniki</router-link>
        </div>



        <div class="list-group compact" v-if="compact">
            <router-link to="/status" active-class="active" exact class="list-group-item list-group-item-action text-center" title="Status">
                <font-awesome-icon icon="info"/>
            </router-link>
            <router-link to="/subpage-one" active-class="active" exact class="list-group-item list-group-item-action text-center" title="Podstran 1">
                <font-awesome-icon icon="chart-line"/>
            </router-link>
            <router-link to="/subpage-two" active-class="active" exact class="list-group-item list-group-item-action text-center" title="Podstran 2">
                <font-awesome-icon icon="question-circle"/>
            </router-link>
            <router-link to="/Query" active-class="active" exact class="list-group-item list-group-item-action text-center" title="Query">
                <font-awesome-icon icon="question-circle"/>
            </router-link>
        </div>

    </div>

</template>

<script>
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faInfoCircle, faChartLine, faQuestionCircle} from '@fortawesome/free-solid-svg-icons'

    library.add(faInfoCircle);
    library.add(faChartLine);
    library.add(faQuestionCircle);

    export default {
        props: ['compact'],
        name: 'SidebarNavigation'
    };
</script>



// WEBPACK FOOTER //
// src/components/SidebarNavigation.vue